const transformObj = (obj, fn) => JSON.parse(JSON.stringify(obj), fn);

export default transformObj;
